<template>
  <div v-click-outside="handlerClickOverlay">
    <form
      class="search-new-d"
      autocomplete="off"
      action="/search/"
      method="get"
      @submit.prevent="submitHandler"
      @keyup.prevent.down="handlerDown"
      @keyup.prevent.up="handlerUp"
    >
      <div class="search-new-d__content">
        <div class="search-new-d__search-input">
          <input-control
            ref="input"
            v-model="query"
            class="_search-d"
            autocomplete="off"
            placeholder="Поиск книг, авторов"
            name="q"
            :loading="loading"
            @focus="handlerFocus"
            @keydown.native.prevent.up
            @clear="handlerClear"
          >
            <template v-slot:prepend>
              <svg class="b24-input-control__control-icon" width="24" height="24">
                <use xlink:href="#Search_24" />
              </svg>
            </template>
          </input-control>
        </div>
        <div class="search-new-d__search-btn">
          <button-control native-type="submit" class="_search-d">
            Найти
          </button-control>
        </div>
      </div>
      <suggest-list-search-d
        v-if="showSuggests"
        :list="suggestsList"
        :is-loading="loading"
        :popular="popular"
        :history="history"
        :is-show-error="showError"
        :is-query-already-exist="isQueryAlreadyExist"
        :query="query"
        @clear-history="clearHistory"
        @setCurrentLinkTitle="setCurrentLinkTitle"
      />
    </form>
  </div>
</template>

<script>
import { InputControl, ButtonControl } from '@book24/ui-components';
import { reactive, toRefs, onMounted } from '@vue/composition-api';

import SuggestListSearchD from '@/js/vue/SuggestListSearchD';

import useSearch from '@/js/vue/_composition/searchLine/useSearch';

export default {
  name: 'SearchLineD',
  components: {
    InputControl,
    ButtonControl,
    SuggestListSearchD,
  },
  props: {
    dataset: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    const searchComposition = useSearch(props, context);

    const state = reactive({
      isQueryAlreadyExist: false,
    });

    onMounted(() => {
      searchComposition.getPopularPhrases();
      searchComposition.getHistory();

      if (props.dataset.query) {
        searchComposition.query.value = props.dataset.query;
      }

      searchComposition.isQueryAlreadyExist
        .value = searchComposition.checkExistParam(props.dataset.value);
    });

    return {
      ...toRefs(state),
      ...searchComposition,
    };
  },
};
</script>
